import { render, staticRenderFns } from "./PxHeader.vue?vue&type=template&id=fecf1b1e&"
import script from "./PxHeader.vue?vue&type=script&lang=js&"
export * from "./PxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports